module.exports = __webpack_public_path__ + "img/coinbankB02.eae3b6e8.jpg";